














import {
  defineComponent, computed,
  useContext,
} from '@nuxtjs/composition-api';
import { SfBreadcrumbs } from '~/components/StorefrontUi';
import { useUiHelpers } from '~/composables';
import { STORE_URL } from '~/config/base';
import { useTraverseCategory } from '~/modules/catalog/category/helpers/useTraverseCategory';

export default defineComponent({
  components: { SfBreadcrumbs },
  setup() {
    const { getCatLink } = useUiHelpers();
    const { categoryAncestors } = useTraverseCategory();
    const { localePath, i18n } = useContext();

    const breadcrumbs = computed(() => ([
      {
        text: `${i18n.t('Homepage')}`,
        link: localePath('/'),
      },
      ...categoryAncestors.value
        .map((category) => ({
          text: category.name,
          link: getCatLink(category),
        })),
    ]));

    const getBreadcrumbsSchema = () => (JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: breadcrumbs.value.map((breadcrumb, index) => ({
        '@type': 'ListItem',
        position: index + 1,
        name: breadcrumb.text,
        item: `${STORE_URL}${breadcrumb.link}`,
      })),
    }));

    return {
      getBreadcrumbsSchema,
      breadcrumbs,
    };
  },
});
